export default "__VITE_ASSET__a9ae76c2__"